const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7104",
  "data-name": "Path 7104",
  d: "M6.544,15.654,4.439,14.641,2.784,13.127l-.936-2.043L1.509,8.753l.2-2.391.8-2.134,1.753-1.5,2.1-1.047L8.7,1.508l2.349.322,2.067.983L14.709,4.42l.986,2.168.6,2.25L15.838,11,14.56,13.124l-1.345,1.952-2.045.832-2.339.236ZM8.747,0,5.957.211,3.424,1.472,1.236,3.34l-1,2.691L0,8.8l.394,2.714,1.152,2.517L3.589,15.9l2.466,1.185,2.692.579,2.788-.283L14.2,16.3l1.625-2.359,1.432-2.375L17.841,8.8l-.729-2.719L15.963,3.555,14,1.571,11.484.374Z",
  fill: "#905d35"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7105",
  "data-name": "Path 7105",
  d: "M8.74,5.223a.838.838,0,0,1-.321-.062.779.779,0,0,1-.431-.427.833.833,0,0,1-.061-.325.843.843,0,0,1,.068-.335A.922.922,0,0,1,8.176,3.8a.785.785,0,0,1,.267-.181.813.813,0,0,1,.325-.065.754.754,0,0,1,.311.065.77.77,0,0,1,.256.181.85.85,0,0,1,.171.27.869.869,0,0,1,.061.325.83.83,0,0,1-.068.338.787.787,0,0,1-.181.26.843.843,0,0,1-.263.167.823.823,0,0,1-.315.062M8.084,6.8h1.3v7.246h-1.3Z",
  fill: "#905d35"
});
function SvgSidebarInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Group_6749",
    "data-name": "Group 6749",
    width: 17.841,
    height: 17.661,
    viewBox: "0 0 17.841 17.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarInfo);
export default __webpack_public_path__ + "static/media/Sidebar--info.454a3942.svg";
export { ForwardRef as ReactComponent };